/**
 * NotFound.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';

import { Card, PageWrap } from '@minerva-analytics/pantheon';
import CardHeader from 'components/CardHeader';
import CardBody from 'components/CardBody';

/**
 * What to render when we can't find that route!
 *
 */
export default class NotFound extends Component {
  render() {
    return (
      <PageWrap>
        <Card size="medium">
          <CardHeader>
            404 Not Found
          </CardHeader>
          <CardBody>
            Hey! We&apos;re sorry. An error occured and we could not find what you are looking for.
          </CardBody>
        </Card>
      </PageWrap>
    );
  }
}
